import React from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#fff",
        fontFamily: "'Inter', sans-serif",
        color: "#111",
      }}
    >
      {/* Top bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px clamp(20px, 5vw, 40px)",
          borderBottom: "1px solid #eee",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <button
          onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 500,
            color: "#555",
          }}
        >
          <FiArrowLeft size={18} />
          Back
        </button>
        <div style={{ fontWeight: 800, fontSize: "18px", letterSpacing: "-0.02em" }}>
          scribbledraw.
        </div>
      </div>

      <div
        style={{
          maxWidth: "560px",
          margin: "0 auto",
          padding: "48px clamp(20px, 5vw, 40px)",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: 800,
            letterSpacing: "-0.02em",
            marginBottom: "8px",
          }}
        >
          Privacy Policy
        </h1>
        <p style={{ color: "#888", fontSize: "14px", marginBottom: "36px" }}>
          Last updated: February 2026
        </p>

        <Section title="Your Data">
          <p>
            We collect your email (via Google sign-in) to manage your account,
            and process payments securely through Stripe — we never see your
            card details. Your sketches are sent to a third-party AI service
            for generation.
          </p>
          <p>
            Uploaded sketches and generated images are stored for{" "}
            <strong>24 hours only</strong>, then automatically and permanently
            deleted. We do not sell, share, or use your data for advertising.
          </p>
        </Section>

        <Section title="Your Rights">
          <p>
            You can delete your account at any time by contacting us. Since
            uploads and generations are automatically deleted after 24 hours,
            no action is needed to remove that data.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            If you have questions about this privacy policy, reach out at{" "}
            <a
              href="mailto:candywrapperco@gmail.com"
              style={{ color: "#111", fontWeight: 500 }}
            >
              candywrapperco@gmail.com
            </a>
            .
          </p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <h2
        style={{
          fontSize: "17px",
          fontWeight: 700,
          marginBottom: "8px",
        }}
      >
        {title}
      </h2>
      <div
        style={{
          fontSize: "14px",
          color: "#555",
          lineHeight: 1.7,
        }}
      >
        {children}
      </div>
      <style>{`
        div ul { padding-left: 20px; margin: 8px 0; }
        div li { margin-bottom: 6px; }
      `}</style>
    </div>
  );
}
